import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'chart.js';
import { HttpParams } from '@angular/common/http';
// import {connectableObservableDescriptor} from 'rxjs/internal/observable/ConnectableObservable';
import { ApiService } from '../../../services/api.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
var DashboardStorageComponent = (function () {
    function DashboardStorageComponent(translate, apiService, router, authService) {
        this.translate = translate;
        this.apiService = apiService;
        this.router = router;
        this.authService = authService;
        this.monthList = [];
        this.yearList = [];
        this.total = 0;
        this.charts_signing_counter_bar_stacked = null;
        this.charts_signing_counter_bar_stacked_title = '';
        this.selectedMonth = 1;
        this.monthNames = [
            'MONTH.JANUARY',
            'MONTH.FEBRUARY',
            'MONTH.MARCH',
            'MONTH.APRIL',
            'MONTH.MAY',
            'MONTH.JUNE',
            'MONTH.JULY',
            'MONTH.AUGUST',
            'MONTH.SEPTEMBER',
            'MONTH.OCTOBER',
            'MONTH.NOVEMBER',
            'MONTH.DECEMBER'
        ];
        if (this.authService.isAccountant()) {
            this.router.navigate(['/taxReport']);
        }
    }
    DashboardStorageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.get('COMMON.ALL').subscribe(function () {
            _this.populateDropdown();
            _this.loadMonthList();
            _this.loadStorageData();
        });
        this.translate.onLangChange.subscribe(function (event) {
            _this.loadMonthList();
            _this.loadStorageData();
        });
    };
    DashboardStorageComponent.prototype.loadMonthList = function () {
        var _this = this;
        this.monthList = this.monthNames.map(function (monthName) { return _this.translate.instant(monthName); });
    };
    DashboardStorageComponent.prototype.populateDropdown = function () {
        var currentDate = new Date();
        // populate year list back within 10 years
        var thisYear = currentDate.getFullYear();
        for (var i = 0; i <= 10; i++) {
            this.yearList.push({ label: (thisYear - i).toString(), value: thisYear - i });
        }
        // set current month and year
        this.selectedMonth = currentDate.getMonth() + 1;
        this.selectedYear = thisYear;
        // this.loadStorageData();
    };
    //
    // load data from current month
    DashboardStorageComponent.prototype.loadStorageData = function () {
        var _this = this;
        // const storage = [3, 10, 12, 17, 0, 0, 0, 0, 0, 0, 0, 0];
        var params = new HttpParams();
        if (this.selectedYear) {
            params = params.append('year', this.selectedYear);
        }
        this.apiService.getStorageReport(params).subscribe(function (data) {
            _this.total = Math.max.apply(Math, data.storage) * 2;
            _this.create_count_bar_storage(data.storage);
            // this.create_count_bar_storage(storage);
        });
        Chart.plugins.register({
            beforeDraw: function (chart) {
                if (chart.config.options.elements.center) {
                    chart.clear();
                    //  Get ctx from string
                    var ctx = chart.chart.ctx;
                    //  Get options from the center object in options
                    var centerConfig = chart.config.options.elements.center;
                    var fontStyle = centerConfig.fontStyle || 'Arial';
                    var txt = centerConfig.text;
                    var color = centerConfig.color || '#000';
                    var sidePadding = centerConfig.sidePadding || 20;
                    var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
                    //  Start with a base font of 30px
                    ctx.font = '30px ' + fontStyle;
                    var stringWidth = ctx.measureText(txt).width;
                    var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
                    // Find out how much the font can grow in width.
                    var widthRatio = elementWidth / stringWidth;
                    var newFontSize = Math.floor(30 * widthRatio);
                    var elementHeight = (chart.innerRadius * 2);
                    // Pick a new font size so it will not be larger than the height of label.
                    var fontSizeToUse = Math.min(newFontSize, elementHeight);
                    //  Set font settings to draw it correctly.
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
                    var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 1.2);
                    ctx.font = fontSizeToUse + 'px ' + fontStyle;
                    ctx.fillStyle = color;
                    //  Draw text in center
                    ctx.fillText(txt, centerX, centerY);
                }
            },
            afterDraw: function (chart) {
                if (chart.data.datasets.length === 0) {
                    // No data is present
                    var ctx = chart.chart.ctx;
                    var width = chart.chart.width;
                    var height = chart.chart.height;
                    chart.clear();
                    ctx.save();
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.font = '14pt Tahoma';
                    ctx.fillStyle = '#000';
                    ctx.fillText('ไม่ข้อมูลแสดง', width / 2, height / 2);
                    ctx.restore();
                }
            }
        });
    };
    DashboardStorageComponent.prototype.create_count_bar_storage = function (data) {
        var storageData = data;
        var color = Chart.helpers.color;
        // const storageData = [0, 0, 0, 0, 5, 7, 8, 9, 10, 0, 0, 0];
        var storageList = [storageData[0]];
        var difference;
        for (var i = 0; i < storageData.length; i++) {
            difference = storageData[i + 1] - storageData[i];
            if (difference === 0) {
                storageList.push(0);
            }
            else if (difference >= 0) {
                storageList.push(difference);
            }
            else {
                break;
            }
        }
        var layers = [];
        for (var i = 0; i < storageList.length; i++) {
            layers.push(Array(i).fill(0).concat(Array(storageList.length - i).fill(storageList[i])));
        }
        this.charts_signing_counter_bar_stacked_title = 'Storage Dashboard';
        var barChartData = {
            labels: this.monthList,
            datasets: [
                // {
                //   label: this.translate.instant('CHART.STORAGE'),
                //   // backgroundColor: color('rgb(54, 162, 235)').alpha(0.5).rgbString(),
                //   backgroundColor: color('rgb(255, 77, 124)').alpha(0.5).rgbString(),
                //   borderColor: 'rgb(54, 162, 235)',
                //   data: storage
                // },
                {
                    label: this.translate.instant('MONTH.JANUARY'),
                    backgroundColor: color('rgb(192, 0, 0)').alpha(0.5).rgbString(),
                    borderColor: 'rgb(192, 0, 0)',
                    data: layers[0]
                },
                {
                    label: this.translate.instant('MONTH.FEBRUARY'),
                    backgroundColor: color('rgb(167, 0, 100)').alpha(0.5).rgbString(),
                    borderColor: 'rgb(167, 0, 100)',
                    data: layers[1]
                }, {
                    label: this.translate.instant('MONTH.MARCH'),
                    backgroundColor: color('rgb(67, 0, 134)').alpha(0.5).rgbString(),
                    borderColor: 'rgb(67, 0, 134)',
                    data: layers[2]
                }, {
                    label: this.translate.instant('MONTH.APRIL'),
                    backgroundColor: color('rgb(0, 51, 153)').alpha(0.5).rgbString(),
                    borderColor: 'rgb(0, 51, 153)',
                    data: layers[3]
                }, {
                    label: this.translate.instant('MONTH.MAY'),
                    backgroundColor: color('rgb(3, 212, 219)').alpha(0.5).rgbString(),
                    borderColor: 'rgb(3, 212, 219)',
                    data: layers[4]
                }, {
                    label: this.translate.instant('MONTH.JUNE'),
                    backgroundColor: color('rgb(0, 216, 0)').alpha(0.5).rgbString(),
                    borderColor: 'rgb(0, 216, 0)',
                    data: layers[5]
                }, {
                    label: this.translate.instant('MONTH.JULY'),
                    backgroundColor: color('rgb(183, 247, 0 )').alpha(0.5).rgbString(),
                    borderColor: 'rgb(183, 247, 0 )',
                    data: layers[6]
                }, {
                    label: this.translate.instant('MONTH.AUGUST'),
                    backgroundColor: color('rgb(233, 215, 0 )').alpha(0.5).rgbString(),
                    borderColor: 'rgb(233, 215, 0 )',
                    data: layers[7]
                }, {
                    label: this.translate.instant('MONTH.SEPTEMBER'),
                    backgroundColor: color('rgb(234, 94, 0)').alpha(0.5).rgbString(),
                    borderColor: 'rgb(234, 94, 0)',
                    data: layers[8]
                }, {
                    label: this.translate.instant('MONTH.OCTOBER'),
                    backgroundColor: color('rgb(222, 163, 68)').alpha(0.5).rgbString(),
                    borderColor: 'rgb(222, 163, 68)',
                    data: layers[9]
                }, {
                    label: this.translate.instant('MONTH.NOVEMBER'),
                    backgroundColor: color('rgb(224, 76, 242)').alpha(0.5).rgbString(),
                    borderColor: 'rgb(224, 76, 242)',
                    data: layers[10]
                }, {
                    label: this.translate.instant('MONTH.DECEMBER'),
                    backgroundColor: color('rgb(55, 226, 148)').alpha(0.5).rgbString(),
                    borderColor: 'rgb(55, 226, 148)',
                    data: layers[11]
                }
            ]
        };
        if (this.charts_signing_counter_bar_stacked == null) {
            this.charts_signing_counter_bar_stacked = new Chart('storage-counter-bar-chart', {
                type: 'bar',
                data: barChartData,
                options: {
                    tooltips: {
                        titleFontSize: 17,
                        bodyFontSize: 17,
                        mode: 'index',
                        intersect: false,
                        callbacks: this.getFormatLabel('GB', true),
                        filter: function (tooltipItem) {
                            return tooltipItem.datasetIndex === tooltipItem.index;
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                                stacked: true,
                            }],
                        yAxes: [{
                                stacked: true,
                                ticks: {
                                    beginAtZero: true,
                                    max: this.total,
                                    callback: function (value) {
                                        if (value % 1 === 0) {
                                            return value;
                                        }
                                    }
                                }
                            }]
                    },
                    legend: {
                        position: 'top',
                    }
                }
            });
        }
        else {
            this.charts_signing_counter_bar_stacked.config.options.tooltips.callbacks =
                this.getFormatLabel('GB', true);
            this.charts_signing_counter_bar_stacked.data = barChartData;
            this.charts_signing_counter_bar_stacked.update();
        }
    };
    DashboardStorageComponent.prototype.getFormatLabel = function (unitName, showSum) {
        var _this = this;
        var tooltip = {
            label: function (tooltipItem, data) {
                var dataLabel = data.datasets[tooltipItem.datasetIndex].label;
                if (dataLabel == null) {
                    dataLabel = data.labels[tooltipItem.index];
                }
                var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                var valueStr = ' : ' + value.toLocaleString();
                dataLabel += valueStr + ' ' + unitName;
                if (showSum) {
                    var text = data.datasets.reduce(function (accumulator, val) {
                        return val.data[tooltipItem.index] ? accumulator + val.data[tooltipItem.index] : accumulator;
                    }, 0);
                    window['total'] += text;
                }
                return dataLabel;
            }
        };
        if (showSum) {
            tooltip['afterTitle'] = function () {
                window['total'] = 0;
            };
            tooltip['footer'] = function (tooltipItem, data) {
                var text = [_this.translate.instant('CHART.TOTAL') + ' : ' + window['total'].toLocaleString() + ' ' + unitName +
                        ((window['total'] >= 2 && unitName === 'Time') ? 's' : '')];
                return tooltipItem.length ? text : null;
            };
        }
        return tooltip;
    };
    return DashboardStorageComponent;
}());
export { DashboardStorageComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-storage/dashboard-storage.component.ts.pre-build-optimizer.js